
export default function Course() {
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Hero Section */}
      <section className="relative py-20 bg-gray-800">
        <div className="container mx-auto px-6">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-amber-400">
              Music Production Course
            </h1>
            <p className="text-xl md:text-2xl leading-relaxed">
              Learn the art of music production from award-winning composer Kobby Taylor. This comprehensive course covers everything from basic techniques to advanced production methods.
            </p>
          </div>
        </div>
      </section>

      {/* Course Content Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <div className="bg-gray-800 p-8 md:p-12 rounded-lg mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-amber-400">
                What You'll Learn
              </h2>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-music-2-line text-xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Production Fundamentals</h3>
                    <p className="text-lg leading-relaxed">
                      Master the essential techniques and tools used in modern music production.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-equalizer-line text-xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Mixing &amp; Mastering</h3>
                    <p className="text-lg leading-relaxed">
                      Learn professional mixing and mastering techniques to polish your tracks.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-headphone-line text-xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Sound Design</h3>
                    <p className="text-lg leading-relaxed">
                      Create unique sounds and textures that define your musical identity.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-rhythm-line text-xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Composition Techniques</h3>
                    <p className="text-lg leading-relaxed">
                      Develop your compositional skills across multiple genres and styles.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* YouTube Playlist Embed */}
            <div className="bg-gray-800 p-8 md:p-12 rounded-lg mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-amber-400">
                Course Videos
              </h2>
              <div className="aspect-video w-full">
                <iframe
                  className="w-full h-full rounded-lg shadow-2xl"
                  src="https://www.youtube.com/embed/videoseries?list=PLGdeIRspQzmQBFomQGaAI6ceooMygFICV"
                  title="Music Production Course Playlist"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <p className="text-center text-lg mt-6 text-gray-300">
                Watch the full playlist on YouTube and follow along at your own pace
              </p>
            </div>

            {/* Student Work Section */}
            <div className="bg-gray-800 p-8 md:p-12 rounded-lg mb-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center text-amber-400">
                Beats Bus x Producer Giveaway
              </h2>
              <p className="text-center text-lg mb-8 text-gray-300">
                Listen to the amazing tracks created by students who took this course
              </p>
              <div className="flex justify-center">
                <a
                  href="https://soundcloud.com/user-791313842/sets/producer-giveaway"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 bg-amber-500 hover:bg-amber-600 text-black font-semibold px-8 py-4 rounded-lg transition-colors duration-300 cursor-pointer whitespace-nowrap text-lg"
                >
                  <i className="ri-soundcloud-line text-2xl"></i>
                  Listen on SoundCloud
                </a>
              </div>
              <p className="text-center text-lg mt-6 text-gray-300">
                These tracks showcase the real-world results students achieve through the course
              </p>

              {/* Kids Jamming Video */}
              <div className="mt-12">
                <h3 className="text-2xl font-bold mb-6 text-center text-amber-400">
                  Students in Action
                </h3>
                <div className="flex justify-center">
                  <div className="w-full max-w-md">
                    <div className="relative" style={{ paddingBottom: '177.78%' }}>
                      <iframe
                        className="absolute top-0 left-0 w-full h-full rounded-lg shadow-xl"
                        src="https://www.youtube.com/embed/SFbCuXAql3w"
                        title="Students Jamming"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>
                <p className="text-center text-lg mt-6 text-gray-300">
                  Watch young producers creating music together
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
